import { NgModule } from "@angular/core"
import { CommonModule } from "@angular/common"
import { ImagesEventCarouselComponent } from "./images-event-carousel.component"
import { OptionsNgxOwCarouselService } from "dmmp-services"
import { CarouselModule } from "ngx-owl-carousel-o"
import { BrowserModule } from "@angular/platform-browser"
import { BrowserAnimationsModule } from "@angular/platform-browser/animations"

@NgModule({
  declarations: [ImagesEventCarouselComponent],
  imports: [
    CommonModule,
    BrowserAnimationsModule,
    BrowserModule,
    CarouselModule,
    CommonModule,
  ],
  exports: [ImagesEventCarouselComponent],
})
export class ImagesEventCarouselModule {}
